import { gql } from '@apollo/client';

export const DELETE_ADDITIONAL_PAINTING_IMAGE = gql`
  mutation DeleteAdditionalPaintingImage($id: Int!) {
    success: deleteAdditionalPaintingImage(id: $id)
  }
`;
